import React from 'react';
import { __ } from '@wordpress/i18n';

// store
import { useStoreValue } from '../../store';

// components
import DomandeTablePreInstructorAsync from '../DashboardPreInstructor/components/DomandeTablePreInstructorAsync';

const DomandePreInstructor = () => {
    const userData = useStoreValue('userData');

    return(
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Domande da valutare', 'htr')}</h1>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <DomandeTablePreInstructorAsync userId={userData.id}/>
            </div>
        </div>
    )
}

export default DomandePreInstructor;